import styled from 'styled-components'
import { colors } from '../../theme'

export const DivHelp = styled.div`
  font-size: 26px;
  color: ${colors.grey500};
  padding-right: 10px;
  cursor: pointer;

  :hover {
    cursor: pointer;
    color: ${colors.help};
  }
`
